import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getCurrentInstance, onMounted } from 'vue'
import { ElConfigProvider } from 'element-plus'
import { storage } from '@/utils/tool'
import zh_cn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import fr from 'element-plus/dist/locale/fr.mjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const langComponent: any = {
  zh_CN: zh_cn,
  en: en,
  fr: fr
}
const { proxy } = getCurrentInstance() as any
// 获取语言版本
const lang = storage.getStringItem('LANG') || proxy.$config.LANG
const locale = langComponent[lang] // 获取到的lang-----'"zh_CN"'
onMounted(() => {
  proxy.$i18n.locale = lang
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(locale) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})